// extracted by mini-css-extract-plugin
export var characters = "characters-module--characters--F4yv4";
export var title = "characters-module--title--60MyY";